// jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// Material Dashboard JS
import './material-dashboard.js';

// DataTables
import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';

// Custom scripts
import './custom.js';
import './prevent-double-click.js'

// TinyMCE
import 'tinymce/tinymce.js';
import 'tinymce/icons/default/icons.js';
import 'tinymce/themes/silver/theme.js';
import 'tinymce/models/dom/model.js';

// Auto Logout Script
// import './auto-logout.js';

// Popper.js
import * as Popper from '@popperjs/core';
window.Popper = Popper;

// Bootstrap
import 'bootstrap';

// Select2
import select2 from 'select2';
window.select2 = select2;

// SweetAlert2
import Swal from 'sweetalert2';
window.Swal = Swal;

// Lodash
import lodash from 'lodash';
window._ = lodash;

// Axios
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Laravel Vapor
import Vapor from 'laravel-vapor';
window.Vapor = Vapor;

// Sentry Setup
import * as Sentry from '@sentry/browser';
Sentry.init({
  dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
});
